export const headTools = [
  {
    icon: require('../assets/tools/capital.png'),
    titleUz: 'Amir Temur davlati poytaxti',
    titleEng: "The capital of Temur's empire",
    id: 'SAMARQAND',
  },
  {
    icon: require('../assets/tools/country.png'),
    titleUz: 'Boshqa davlatlar poytaxti',
    titleEng: 'Capitals of other countries',
  },
  {
    icon: require('../assets/tools/greenine.png'),
    titleUz: 'Amir Temur davlati',
    titleEng: 'The Amir Temur’s empire',
    id: 'greenGround',
  },
  {
    id: 'yellowGround',
    icon: require('../assets/tools/yellowline.png'),
    titleUz: "Amir Temurga bo'ysinuvchi, qaram davlatlar va hududlar chegaralari",
    titleEng: "The territories of the vassal countries depended on Temur's empire",
  },
  {
    icon: require('../assets/tools/swords.png'),
    titleUz: "Muhim bo'lgan janglar va yillar",
    titleEng: 'Battles and years that mattered',
  },
];
